export default {
    notStarted: 'not started',
    pending: 'pending',
    success: 'success',
    error: 'error',
    loggingOut: 'logging out'
};
